const FREE_SAMPLE_PRODUCT_TYPE = "Free Samples";

export const sortLinesByPriceAndFreeSamples = (lines, freeSamplesAdded) => {
  return lines.sort((a, b) => {
    const isFreeSampleA = freeSamplesAdded.includes(a.product_id);
    const isFreeSampleB = freeSamplesAdded.includes(b.product_id);
    if (isFreeSampleA && isFreeSampleB) {
      return b.final_price - a.final_price;
    }
    if (isFreeSampleA) return 1;
    if (isFreeSampleB) return -1;
    return b.final_price - a.final_price;
  });
};

export const freeSamplesAddedToCart = (products, freeSamples) => {
  const freeSamplesProductsIds = freeSamples?.products?.map((product) =>
    Number(product.id.split("/").pop())
  );
  return products
    ? products.reduce((acc, product) => {
        if (
          product?.product_type === FREE_SAMPLE_PRODUCT_TYPE &&
          freeSamplesProductsIds.includes(product.product_id)
        ) {
          acc.push(product.product_id);
        }
        return acc;
      }, [])
    : null;
};
